/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/9/22, 8:25 AM
 *
 */

import React from 'react';
import { toast } from 'react-hot-toast';
import { QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from 'stores';

import { queryClient } from 'config/queryClient';

import 'assets/sass/styles.scss';

import { Badge } from '@sunyahealthnepal/react-ui-components';
import ToastBase from 'components/ToastBase';
import Router from 'routes';

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <Router />
          <ToastBase />
        </PersistGate>
      </Provider>
    </QueryClientProvider>
  );
}

export const Dashboard = () => {
  return (
    <div
      className="flex cursor-pointer items-center justify-center fill-primary-500 text-red-500 sm:bg-white "
      onClick={() => {
        toast.success('This is successful');
      }}
    >
      <Badge type="info" trueStatement="Hello" />
    </div>
  );
};

export const NotFoundPage = () => {
  return (
    <div className="text-display-2xl flex min-h-screen items-center justify-center bg-gray-600 text-white ">
      404
    </div>
  );
};

export const Login = () => {
  return (
    <div className="text-display-2xl flex min-h-screen items-center justify-center bg-gray-600 text-white ">
      Login
    </div>
  );
};

export const Redirect = () => {
  return (
    <div className="text-display-2xl flex min-h-screen items-center justify-center bg-gray-600 text-white ">
      Redirecting To Login
    </div>
  );
};
export default App;
